import styled from "styled-components";

export const HeaderLeft = styled.div`
  display: flex;
`;

export const HeaderCenter = styled.div`
  flex-grow: 1;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  overflow: visible !important;

  button.ui.button {
    margin: auto 2px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    i {
      margin: 0 !important;
      line-height: 18px !important;
      opacity: 0.99 !important;
    }
  }
`;

export const HeaderTab = styled.div`
  display: flex;
  position: relative;
  z-index: 0;

  &:before {
    content: "";
    position: absolute;
    right: -17px;
    top: 13px;
    width: 34px;
    height: 34px;
    box-shadow: 4px -4px 10px -2px #032230;
    transform: rotate(45deg) skew(15deg, 15deg);
    z-index: -1;
    background: ${props => props.theme.primary};
  }

  > * {
    background: ${props => props.theme.primary};
  }

  &.clickable {
    cursor: pointer;
    &:hover {
      &:before {
        background: #175c79;
      }
      > * {
        background: #175c79;
      }
    }
  }
`;

export const Logo = styled.div`
  display: inline-block;
  padding: 11px 10px;
  cursor: default;

  img {
    width: 27px;
  }
`;

export const Title = styled.div`
  color: #f1f4f5;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: default;
  padding-right: 19px;
`;

export const Breadcrumb = styled.div`
  cursor: default;
  color: #fff;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 45px;
  padding-right: 19px;

  [role="combobox"] {
    white-space: nowrap !important;
    z-index: 1;
  }

  [role="combobox"]:not(.active) {
    background: transparent !important;
    color: white !important;
    border: none !important;
    min-width: auto !important;
    padding-top: 23px;
    padding-bottom: 24px;
    border-radius: 0;

    &:hover {
      background: ${props => props.theme.primaryLight} !important;
    }

    i {
      opacity: 0.99 !important;
      padding-top: 24px !important;
    }

    .text,
    input {
      cursor: pointer !important;
    }
  }
`;

export const BreadcrumbDivider = styled.div`
  cursor: default;
  color: #fff;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 14px;
`;

export const DimmerStyle = styled.div`
  background: transparent !important;
`;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/MagnetReportHeader/style.js